import { Factory } from 'fishery'
import { formatDatepickerDate } from 'utils/date'
import { EligiblePerson_eligiblePersonById as TEligiblePerson } from '../queries/types/EligiblePerson'
import { EnrollmentEventAction } from '../types/graphql-global-types'

const formattedToday = () => {
  return formatDatepickerDate(new Date())
}
type EligiblePersonTransientParams = {
  terminationDate?: string
}

const eligiblePersonFactory = Factory.define<
  TEligiblePerson,
  EligiblePersonTransientParams
>(({ transientParams, sequence }) => {
  const { terminationDate } = transientParams

  return {
    id: `${sequence}`,
    firstName: `Eligible${sequence}`,
    lastName: `Person${sequence}`,
    emailAddress: `person${sequence}@company.com`,
    enrollment: {
      __typename: 'Enrollment',
      accessToken: `accessToken${sequence}`,
      cmsRiderLink: `cmsRiderLink${sequence}`,
      enrollmentEvents: [
        {
          __typename: 'EnrollmentEvent',
          id: `${sequence}`,
          action: EnrollmentEventAction.CREATE,
          eventDate: formattedToday(),
          partnerName: `partnerName${sequence}`,
        },
      ],
    },
    currentEligibility: {
      __typename: 'EligibilityPeriod',
      effectiveDate: formattedToday(),
      terminationDate: terminationDate || formattedToday(),
    },
    eligibilityPeriods: [
      {
        __typename: 'EligibilityPeriod',
        id: 'abc123',
        effectiveDate: formattedToday(),
        terminationDate: terminationDate || formattedToday(),
      },
    ],
    sponsor: {
      __typename: 'Sponsor',
      name: 'Sponsor',
    },
    partner: {
      __typename: 'Partner',
      id: 'abc123def456',
      name: 'Partner',
    },
    magicLink: null,
    __typename: 'EligiblePerson',
  }
})

export { eligiblePersonFactory }
